import React, { useEffect, useRef, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Circle,
  useMap,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";

// Fix default marker icons (Leaflet + bundlers)
const icon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Helper to update map center when lat/lng change (avoids remount)
function Recenter({ lat, lng, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) map.setView([lat, lng], zoom);
  }, [lat, lng, zoom, map]);
  return null;
}

// Clique no mapa reposiciona o pino (somente no modo editável)
function ClickToSet({ onPositionChange }) {
  useMapEvents({
    click(e) {
      onPositionChange?.(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

export function MapView({
  lat,
  lng,
  popup,
  height = 220,
  radius = null,
  zoom = 16,
  editable = false,
  onPositionChange = null,
  testId = "map-view",
}) {
  // Defer mount one tick to avoid React StrictMode double-mount issue with Leaflet
  const [ready, setReady] = useState(false);
  const mountedRef = useRef(false);
  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;
    const t = setTimeout(() => setReady(true), 0);
    return () => clearTimeout(t);
  }, []);

  if (!lat || !lng) {
    return (
      <div
        data-testid={`${testId}-empty`}
        className="cm-card flex items-center justify-center text-sm text-slate-500"
        style={{ height }}
      >
        Sem coordenadas
      </div>
    );
  }
  if (!ready) {
    return (
      <div
        data-testid={`${testId}-loading`}
        className="cm-card flex items-center justify-center text-sm text-slate-400"
        style={{ height }}
      >
        Carregando mapa…
      </div>
    );
  }
  return (
    <div
      data-testid={testId}
      className="overflow-hidden rounded-xl border border-slate-200"
      style={{ height }}
    >
      <MapContainer
        center={[lat, lng]}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <Recenter lat={lat} lng={lng} zoom={zoom} />
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {editable && <ClickToSet onPositionChange={onPositionChange} />}
        <Marker
          position={[lat, lng]}
          icon={icon}
          draggable={editable}
          eventHandlers={
            editable
              ? {
                  dragend: (e) => {
                    const p = e.target.getLatLng();
                    onPositionChange?.(p.lat, p.lng);
                  },
                }
              : undefined
          }
        >
          {popup && <Popup>{popup}</Popup>}
        </Marker>
        {radius && (
          <Circle
            center={[lat, lng]}
            radius={radius}
            pathOptions={{ color: "#2563eb", fillOpacity: 0.08 }}
          />
        )}
      </MapContainer>
    </div>
  );
}
